import { render, staticRenderFns } from "./stockhistory.vue?vue&type=template&id=0197d339&scoped=true"
import script from "./stockhistory.vue?vue&type=script&lang=js"
export * from "./stockhistory.vue?vue&type=script&lang=js"
import style0 from "./stockhistory.vue?vue&type=style&index=0&id=0197d339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197d339",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
